import { render, staticRenderFns } from "./Document_Passport.vue?vue&type=template&id=48cc0142&scoped=true&"
import script from "./Document_Passport.vue?vue&type=script&lang=js&"
export * from "./Document_Passport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cc0142",
  null
  
)

export default component.exports